<!-- sports-table.component.html -->
<table
  mat-table
  [dataSource]="sports"
  class="mat-elevation-z1"
  style="width: 100%"
  aria-describedby="metric settings list">

  <!-- Sport Column -->
  <ng-container matColumnDef="sport">
    <th
      scope="row"
      mat-header-cell
      *matHeaderCellDef
      class="mat-column-sport">
      Sport
    </th>
    <td mat-cell *matCellDef="let sport">{{ sport.name }}</td>
  </ng-container>

  <!-- Determination Method Column -->
  <ng-container matColumnDef="determination">
    <th
      scope="row"
      mat-header-cell
      *matHeaderCellDef
      class="mat-column-determination">
      How to determine max aerobic speed/power
    </th>
    <td mat-cell *matCellDef="let sport">
      <div class="determination-content">
        <ng-container *ngIf="sport.hasToggle">
          <div class="toggle-row">
            <span>based on:</span>
            <span>Distance</span>
            <mat-slide-toggle
              [checked]="sport.isDuration"
              (change)="onToggleChange($event, sport)"
              color="primary">
            </mat-slide-toggle>
            <span>Duration</span>
          </div>
        </ng-container>

        <div class="no-toggle-container" *ngIf="!sport.hasToggle">
          <!-- Empty cell for sports without toggle -->
        </div>
      </div>
    </td>
  </ng-container>

  <!-- Value Column -->
  <ng-container matColumnDef="value">
    <th
      scope="row"
      mat-header-cell
      *matHeaderCellDef
      class="mat-column-value">
      Value
    </th>
    <td mat-cell *matCellDef="let sport">
      <mat-form-field
        appearance="outline"
        class="value-input"
        [class.mat-form-field-invalid]="hasError(sport)">
        <input
          matInput
          [(ngModel)]="sport.value"
          [placeholder]="getPlaceholder(sport)"
          [class.mat-input-invalid]="hasError(sport)"
          type="text"
          maxlength="10"
          (keypress)="onKeyPress($event, sport)"
          (paste)="onPaste($event, sport)"
          (input)="onInputChange($event, sport)">
        <mat-icon matSuffix *ngIf="sport.isDuration">timer</mat-icon>
        <mat-icon matSuffix *ngIf="!sport.isDuration">straighten</mat-icon>
        <mat-error *ngIf="hasError(sport)">
          {{ getInputError(sport) }}
        </mat-error>
      </mat-form-field>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

  <tr class="mat-row no-data-row" *matNoDataRow>
    <td class="mat-cell" colspan="3">No data available in table</td>
  </tr>
</table>
